
import {
  defineComponent, reactive, toRefs, watch,
} from 'vue';
import { IDadosRelatorio } from '@/models/Entidades/Relatorios/DadosRelatorio';
import SelecionarCamposRelatorioPCP from '@/components/Relatorios/PCP/SelecionarCamposRelatorioPCP.vue';
import SelecionarTipoProducao from '@/components/Cadastros/PCP/SelecionarTipoProducao.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarTipoFiltroRelatorioPCP from './SelecionarTipoFiltroRelatorioPCP.vue';
import SelecionarEngenhariaProducao from '@/components/Cadastros/PCP/SelecionarEngenhariaProducao.vue';

export default defineComponent({
  name: 'CriacaoEdicaoLayoutPCPModal',
  components: {
    SelecionarCamposRelatorioPCP,
    SelecionarTipoProducao,
    SelecionarProduto,
    SelecionarTipoFiltroRelatorioPCP,
    SelecionarEngenhariaProducao,
  },
  props: {
    visible: { type: Boolean, required: true },
    modoEdicao: { type: Boolean, default: false },
    codigoEmpresa: { type: Number, required: true },
    dadosCadastroInit: { type: Object as () => IDadosRelatorio, required: true },
    dadosRelatorioCamposInit: { type: String, default: '' },
    tipoProducaoModalInit: { type: Array as () => number[], default: () => [] },
    engenhariaProdutosModalInit: { type: Array as () => number[], default: () => [] },
    materiasPrimasModalInit: { type: Array as () => number[], default: () => [] },
  },
  emits: ['update:visible', 'salvar'],
  setup(props, { emit }) {
    const state = reactive({
      dadosCadastro: {} as IDadosRelatorio,
      dadosRelatorioCampos: '',
      tipoProducao: [] as number[],
      engenhariaProdutos: [] as number[],
      materiasPrimas: [] as number[],
    });

    const fecharModal = () => {
      emit('update:visible', false);
    };

    const salvarLayout = () => {
      emit('salvar', {
        dadosCadastro: state.dadosCadastro,
        dadosRelatorioCampos: state.dadosRelatorioCampos,
        tipoProducaoModal: state.tipoProducao,
        engenhariaProdutosModal: state.engenhariaProdutos,
        materiasPrimasModal: state.materiasPrimas,
      });
    };

    watch(() => props.visible, (isVisible) => {
      if (isVisible) {
        state.dadosCadastro = JSON.parse(JSON.stringify(props.dadosCadastroInit)) as IDadosRelatorio;
        state.dadosRelatorioCampos = props.dadosRelatorioCamposInit;
        state.tipoProducao = [...props.tipoProducaoModalInit];
        state.engenhariaProdutos = [...props.engenhariaProdutosModalInit];
        state.materiasPrimas = [...props.materiasPrimasModalInit];
      }
    });

    return {
      ...toRefs(state),
      fecharModal,
      salvarLayout,
    };
  },
});
